import { CommonModule } from "@angular/common";
import { NgModule, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import {
    SvgRegistryService,
    svgCross,
    svgArrowLeft,
    svgArrowRight,
    SvgIconComponent,
} from "@hermes/aphrodite-svg";
import { TrayStateModule } from "@hermes/hermes-web-states-tray-state";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";
import { IsoCountryCodePipeModule } from "@hermes/utils-generic-pipes-iso-country-code";

import { AccountCreationBannerComponent } from "./components/account-creation-banner/account-creation-banner.component";
import { BannersTopContainerComponent } from "./components/banners-top-container/banners-top-container.component";
import { CookieBannerComponent } from "./components/cookie-banner/cookie-banner.component";
import { CookieLinkComponent } from "./components/cookie-link/cookie-link.component";
import { NotificationBannerComponent } from "./components/notification-banner/notification-banner.component";
import { NotificationMessageComponent } from "./components/notification-message/notification-message.component";
import { NotificationSliderComponent } from "./components/notification-slider/notification-slider.component";
import { BannerAnalyticsService } from "./services/banner-analytics.service";

@NgModule({
    imports: [
        CommonModule,
        SvgIconComponent,
        TranslateModule,
        IsoCountryCodePipeModule,
        TrayStateModule,
        SrOnlyNoSnippetDirective,
        CookieLinkComponent,
        NotificationSliderComponent,
        NotificationMessageComponent,
        NotificationBannerComponent,
        AccountCreationBannerComponent,
        CookieBannerComponent,
        BannersTopContainerComponent,
    ],
    providers: [BannerAnalyticsService],
    exports: [
        AccountCreationBannerComponent,
        BannersTopContainerComponent,
        NotificationBannerComponent,
    ],
})
export class BannersModule {
    constructor() {
        const svgRegistryService = inject(SvgRegistryService);

        svgRegistryService.registerSvgs([
            svgCross,
            svgArrowLeft,
            svgArrowRight,
        ]);
    }
}
